<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<mat-extended-select
	[placeholder]="placeholder"
	[required]="false"
	[option$]="locationList$"
	[includeFilter]="true"
	[multiSelect]="false"
	[formControl]="internalField"
	[sortCompareFunction]="alphaSortButWithNoneFirst"
	[labelPath]="['view', 'name']"
	[valuePath]="['$id']"
	[includeNotSetOption]="includeNotSetOption"
	[isNotSetValid]="true"
	[notSetLabel]="notSetLabel"
	[iconBackgroundColorPath]="['view', 'color']"
	subScriptSizing="dynamic"
>
</mat-extended-select>
